import {
  QueryClient,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { fetchCreateRestriction } from './service';
import { RestrictionQueryKey } from '../../queryKeys';
import { useModal } from '@starsoft/common/hooks';
import { ModalsKey } from '@/enums/modalsKey';
import { useNotificationService } from '@/hooks/notifications/useNotificationService';

export function useCreateRestriction() {
  const queryClient: QueryClient = useQueryClient();
  const { onClose } = useModal(ModalsKey.Restriction);
  const { NotificationsService } = useNotificationService();

  function onSuccess() {
    queryClient.invalidateQueries({
      queryKey: [RestrictionQueryKey.Primary],
    });

    NotificationsService.success({ message: 'created_restriction_message' });

    onClose(true);
  }

  const { isPending, mutate } = useMutation({
    onSuccess,
    mutationFn: fetchCreateRestriction,
  });

  return {
    createRestriction: mutate,
    loadingCreateRestriction: isPending,
  };
}
